export interface ITranslation {
  get: Function
  loadPage: Function
}

export default defineNuxtPlugin((nuxtApp) => {
  const { $api: api } = useNuxtApp()

  const dictionnary: { [pageId: string]: { [code: string]: string } } = {}

  let currentPageId: string
  const loadPage = async (pageId: string) => {
    if (dictionnary[pageId]) return
    currentPageId = pageId
    let filterPage = `filter[id][_eq]=${pageId}`
    let filterLanguage = `filter[labels][translations][languages_code][_eq]=fr-FR`
    let page = await api.cms.get(
      'labels_collections',
      `fields[]=*&fields[]=labels.*&fields[]=labels.translations.*&${filterPage}&${filterLanguage}`,
    )

    page.data[0].labels.forEach((label: any) => {
      if (!dictionnary[pageId]) dictionnary[pageId] = {}
      dictionnary[pageId][label.code] = label.translations[0].value
    })
  }

  const get = (code: string, values?: []) => {
    let stringToReturn = dictionnary[currentPageId][code] || code
    if (values) {
      values.forEach((value) => {
        Object.keys(value).forEach((key) => {
          stringToReturn = stringToReturn.replace(`{{${key}}}`, value[key])
        })
      })
    }

    return stringToReturn
  }

  const modules: ITranslation = {
    loadPage,
    get,
  }
  return {
    provide: {
      text: modules,
    },
  }
})
